import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=c5b51068&scoped=true&"
import script from "./emailTemplate.vue?vue&type=script&lang=js&"
export * from "./emailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=c5b51068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b51068",
  null
  
)

component.options.__file = "emailTemplate.vue"
export default component.exports